<template>
<div>

  <nav class="sticky">
    <header>
      <div class="header-top">
        <router-link :to="{ name: 'Dashboard' }"><h1>Forms Backend</h1></router-link>
        <div v-bind:class="{hidden: !menuVisible}" class="menu">
          <ul>
            <li><router-link v-if="!user" :to="{ name: 'Settings' }">Settings</router-link></li>
            <li @click="logout">Logout</li>
            <li>
              <label v-if="hideDisabled"><toggle-button v-model="hideDisabled"/><span>Hide Disabled Forms</span></label>
              <label v-else><toggle-button v-model="hideDisabled"/><span>Show Disabled Forms</span></label>
            </li>
          </ul>
        </div>
        <div v-bind:class="{hidden: !searchVisible}" class="search">
          <input type="text" v-model="search" placeholder="Search forms...">
        </div>
      </div>
      <div class="button-frame" v-bind:class="{full: user}">
      <nav>
         <menu-icon @click="toggleMenu" />
         <search-icon @click="toggleSearch" />
      </nav>
      <nav>
        <div class="connection" v-bind:class="{connected: connected}"  @click="connectSocket">
          <radio-icon/>
        </div>
      </nav>
      </div>
    <router-link v-if="!user" :to="{ name: 'Create' }" class="button large"
      v-bind:class="{selected:(create)}" @click="createForm">
      <plus-icon class="icon"></plus-icon>
      <span class="form-details">New Form</span>
    </router-link>
    </header>
    <!-- eslint-disable-next-line max-len -->
    <svg height="0" width="0"><defs><clipPath id="svgPath"><path d="m 0,0 0,110 89,0 0,-50 c 0,-40 40,-40 40,-40 l 140,0 c 40,0 40,40 40,40 l 0,0 200,0 0,-200 z"></path></clipPath></defs></svg>
  </nav>

  <div v-if="!forms" class="spinner" role="spinner"><div class="spinner-icon"></div></div>

  <router-link :to="{ path: `/${form.id}` }" v-for="form in formsList" class="form card"
    :data-form="form.id" :key="form.id"
    v-bind:class="{selected:(selectedForm === form.id && !create), enabled: form.enabled, disabled: !form.enabled}">

    <div class="form-details">
      <div class="form-name">{{form.name}}</div>
      <div v-if="form.domain" class="form-domain">{{form.domain}}</div>
    </div>

    <router-link :to="{ path: `/${form.id}/entries` }"
      class="form-entries badge is-badge-success" :data-badge="form.newEntries">
      <message-square-icon class="icon"></message-square-icon>
      <span>{{form.entriesCount.total}}</span>
    </router-link>
  </router-link>

</div>
</template>

<script>
import 'bulma-badge/dist/bulma-badge.min.css';
import {
  PlusIcon, MessageSquareIcon,
  MenuIcon, SearchIcon, RadioIcon,
} from 'vue-feather-icons';

// this.forms.find(x => x.id === 'U7bEQV').entriesCount++

export default {
  props: ['forms'],
  data() {
    return {
      // forms: null,
      selectedForm: '',
      create: false,
      connected: false,
      search: '',
      searchVisible: false,
      menuVisible: false,
      hideDisabled: true,
    };
  },
  computed: {
    user: {
      get() { return this.$store.state.user; },
    },
    formsList() {
      let formsList = [...this.forms || []];
      if (formsList.length > 0) {
        formsList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        if (this.search) formsList = formsList.filter((form) => form.name.toLowerCase().includes(this.search.toLowerCase()));
        if (this.hideDisabled && !this.search) formsList = formsList.filter((form) => form.enabled);
      }
      return formsList;
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === 'Create') this.create = true;
      if (from.name === 'Create') this.create = false;
      if (to.name === 'Form-details') {
        this.selectedForm = to.params.id;
        this.forms.find((x) => x.id === to.params.id).newEntries = 0;
        if (from.name === 'Form-details') this.forms.find((x) => x.id === from.params.id).newEntries = 0;
      }
      if (to.name === 'Form-entries') {
        this.$router.push(`/${to.params.id}/entries`);
        this.selectedForm = to.params.id;
      }
      if (to.name === 'Dashboard') {
        this.selectedForm = null;
      }
    },
  },
  async mounted() {
    this.connectSocket();
    if (this.$route.name === 'Create') this.create = true;
    if (this.$route.params.id) this.selectedForm = this.$route.params.id;
  },
  methods: {
    async selectForm(id) {
      this.$router.push(`/${id}`);
    },
    createForm() {
      this.create = true;
      this.$router.push({ name: 'Create' });
    },
    connectSocket() {
      this.$socket.disconnect();
      this.$socket.io.uri = `${this.$store.getters.endpoint}?token=${this.$store.getters.token}`;
      this.$socket.open();
    },
    toggleSearch() {
      this.menuVisible = false;
      this.search = '';
      this.searchVisible = !this.searchVisible;
      if (this.searchVisible) document.querySelectorAll('header .search input')[0].focus();
    },
    toggleMenu() {
      this.search = '';
      this.searchVisible = false;
      this.menuVisible = !this.menuVisible;
    },
    logout() {
      this.$socket.disconnect();
      this.$router.push('/auth/login');
      this.$store.dispatch('logout');
    },
  },
  sockets: {
    connect() { this.connected = true; }, // eslint-disable-next-line
    disconnect(e) { console.log('WS DC:', e); this.connected = false; },
  },
  components: {
    PlusIcon,
    MessageSquareIcon,
    MenuIcon,
    SearchIcon,
    RadioIcon,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

nav.sticky {
  position: sticky;
  top: 0;
  z-index: 1;
}

header {
  text-align: center;
  position: relative;
  color: var(--white);
  font-family: sans-serif;
}

header .header-top {
  padding-top: 15px;
  background: var(--black);
}

header .header-top a {
  color: white;
  text-decoration: none;
}

header .header-top a:hover {
  text-decoration: underline;
}

header .button-frame {
  background: var(--black);
  height: 60px;
  position: relative;
  clip-path: url(#svgPath);
}

header .button-frame nav svg {
  cursor: pointer;
}

header .button-frame.full { clip-path: none; margin-bottom: 20px;}

header h1 {
  margin: 0;
  padding: 0;
  font-size: 1.7em;
  text-transform: uppercase;
  font-weight: 200;
}

header h1 .icon { vertical-align: middle; }

header nav {
  position: absolute;
  bottom: 5px;
}
header nav:first-of-type { left: 10px; }
header nav:last-of-type  { right: 25px; }
header nav svg { margin-right: 5px; width: 30px; }

header .menu {
  padding-top: 1em;
  height: 70px;
  transition: all 0.5s ease-in-out;
  text-align: center;
}

header .menu a { color: inherit; text-decoration: none; }

header .menu ul {
  columns: 2;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

header .menu li {
  padding-bottom: 0.5em;
}

header .menu .vue-js-switch {
  padding-bottom: 1em;
}

header .menu label span {
  display: block;
  cursor: pointer;
}

header .search {
  height: 80px;
  transition: all 0.5s ease-in-out;
}

header .search input {
  width: 80%;
  padding: 10px;
  margin: 20px;
  border: 0;
  border-radius: 20px;
  text-align: center;
  outline: none;
}

header .hidden {
  height: 0;
  padding: 0;
  opacity: 0;
  pointer-events: none;
}

.button {
  display: inline-flex;
  border-radius: 50px;
  border: 0;
  background: var(--green);
  z-index: 1;
  position: relative;
  height: 60px;
  text-align: center;
  justify-content: center;
  line-height: 60px;
  vertical-align: middle;
  color: var(--white);
  font-weight: 200;
  font-size: 140%;
  text-transform: uppercase;
  text-decoration: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  padding: 20px;
}

.button .icon { width: 25px; }
.button span { line-height: 1em; }
.button.small {
  width: 60px;
  left: calc(50% - 30px);
  margin-top: -30px;
}

.button.large {
  width: 200px;
  left: 3px;
  height: 60px;
  line-height: 60px;
  margin-top: -30px;
}

.button:hover {
  cursor: pointer;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4);
}

.form:first-of-type {
  margin-top: -35px;
}

.form {
  width: 95%;
  height: 80px;
  border-left: 6px solid transparent;
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  padding-left: 0.75em;
  margin: 20px auto;
  display: flex;
  align-items: center;
  transition: background 0.2s ease-in-out;
  cursor: pointer;
  background: white;
  border-radius: 5px;
  transition: box-shadow 0.2s ease-in-out;
  text-decoration: none;
  box-shadow: none;
}

.form.enabled {
  border-left-color: var(--green);
}

.form.disabled {
  border-left-color: var(--red);
}

.form.selected, .form:hover {
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
  background: var(--black);
  color: var(--white);
}

.form.selected .form-domain, .form:hover .form-domain  { color: hsl(0, 0%, 75%); }
.form.selected .form-entries, .form:hover .form-entries { border-color: var(--white); }

.form .icon {
  flex-shrink: 0;
}

.form .form-details {
  display: flex;
  flex-direction: column;
  margin-right: 0.5em;
}

a.form { color: inherit; }

.form .form-name {
  padding-top: 5px;
  font-size: 110%;
}

.form .form-domain {
  font-size: 90%;
  color: hsl(0, 0%, 30%);
}

.form .form-entries {
  color: inherit;
  text-decoration: none;
  text-align: center;
  margin-left: auto;
  flex-shrink: 0;
  width: 50px;
}

.form .form-entries:focus {
  outline: none;
}

.form .form-entries span {
  display: block;
}

.form.selected .form-entries.badge:after { display: none; }
.form .form-entries.badge[data-badge="0"]:after { display: none; }
.form .icon.feather-check-circle { color: var(--green); }
.form .icon.feather-x-circle { color: var(--red); }

.connection { color: var(--red); }
.connected {
  color: var(--green);
  border-radius: 50px;
  position: relative;
}

.connected:before,
.connected:after {
    content: '';
    position: absolute;
    top: -3px;
    left: -0.5px;
    width: 30px;
    height: 30px;
    background: rgba(6, 214, 160, 0.2);
    border-radius: 50px;
    opacity: 0;
 }

.connected:before {
    transform: scale(1);
    animation: pulse 3s infinite cubic-bezier(0.4, 0, 0.2, 1);
}
/* .connected:after { animation: pulse 3s 1s infinite cubic-bezier(0.4, 0, 0.2, 1); } */

.spinner {
  display: block;
  margin: 2rem auto;
  width: 30px;
}

.spinner-icon {
  width: 30px;
  height: 30px;
  box-sizing: border-box;

  border: solid 3px transparent;
  border-top-color: var(--blue);
  border-left-color: var(--blue);
  border-radius: 50%;

  -webkit-animation: nprogress-spinner 400ms linear infinite;
          animation: nprogress-spinner 400ms linear infinite;
}

@-webkit-keyframes nprogress-spinner {
  0%   { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes nprogress-spinner {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

</style>
